import { P0, S, abs, max } from '../../geometry';

export const candle = {
  name: 'Candle',
  colors: ['#161616', '#E3A008'],
  draw(m, t) {
    let h = 16 + 2 * S(t * 7) + S(t * 11),
      s = 2 * S(t * 3),
      wf = 1,
      pose = P0();
    if (m === 'happy') {
      h = 22 + 3 * S(t * 9);
      s = 4 * S(t * 6);
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: the flame dances, tall and swaying.
    if (m === 'thinking') {
      h = 20 + 4 * S(t * 5);
      s = 6 * S(t * 2.5);
    }
    if (m === 'talking') {
      h = 15 + 6 * max(0, S(t * 10));
    }
    if (m === 'surprised') {
      h = 28 + 2 * S(t * 30);
      s = 0;
    }
    if (m === 'paused') {
      h = 6 + S(t * 2);
      s = 0;
      wf = 0.55;
    }
    const flame = [
      [50, 44],
      [50 - 6 * wf + s * 0.3, 38],
      [50 - 5 * wf + s * 0.6, 44 - h * 0.6],
      [50 + s, 44 - h],
      [50 + 5 * wf + s * 0.6, 44 - h * 0.6],
      [50 + 6 * wf + s * 0.3, 38],
      [50, 44],
    ];
    return {
      strokes: [
        {
          c: 'a',
          pts: [
            [38, 51],
            [38, 88],
          ],
        },
        {
          c: 'a',
          pts: [
            [62, 51],
            [62, 88],
          ],
        },
        {
          c: 'a',
          pts: [
            [38, 51],
            [50, 54],
            [62, 51],
          ],
        },
        {
          c: 'a',
          pts: [
            [30, 88],
            [70, 88],
          ],
        },
        {
          c: 'a',
          pts: [
            [50, 52],
            [50, 46],
          ],
        },
        { c: 'b', pts: flame },
      ],
      eyes: { x: 50, y: 69 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f) {
    const [l, r] = [f.strokes[0].pts, f.strokes[1].pts];
    const body = {
      c: 'a',
      fill: true,
      pts: [l[1], l[0], [50, 54], r[0], r[1]],
      sharp: true,
      n: 30,
    };
    return { ...f, strokes: [body, f.strokes[3], f.strokes[4], f.strokes[5]] };
  },
};
